import HundredBricksAPIError from '../HundredBricksAPIError';
class ChangeSessionError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ChangeSessionError', ...args);
    }
}
export default ChangeSessionError;
